import React from 'react'

export default function SubmitButton(props) {
  const {
    SubmitCreateList,
    selectedMovieOrPersonData,
    imagePreview,
    valueEdited,
    editMode,
    sendLoadSpinner,
    listData,
  } = props

  const disableUpdate = () =>
    !(
      listData.title_en &&
      listData.title_te &&
      listData.description_en &&
      listData.description_te &&
      imagePreview &&
      valueEdited &&
      selectedMovieOrPersonData.length >= 1
    )

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button
          type='button'
          className='btn btn-primary'
          onClick={() => {
            sendLoadSpinner(true)
            SubmitCreateList()
          }}
          disabled={disableUpdate()}
        >
          {editMode === 'edit' ? 'Update list' : 'Create list'}
        </button>
      </div>
    </>
  )
}
